<template>
  <ODialog
    ref="dialog"
    :title="$t('alerts.deleteAll.title')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref()

const open = () => {
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.alert.bulkDelete()
    emit('update:loading', false)

    if (response.success) {
      $notification.toast({
        title: $i18n.t('alerts.deleteAll.success'),
        text: $i18n.t('alerts.deleteAll.successInfo'),
        variant: 'success',
      })

      emit('success')

      return true
    }
  } catch (e: any) {
    emit('update:loading', false)
    console.log(e)

    $notification.error({ errors: e?.errors })

    emit('error')
  }
}

defineExpose({
  open,
})
</script>
